export default __webpack_public_path__ + "static/media/AkinShonibare.f12fb472.jpeg";